import { Info } from "lucide-react";

export default function FilterNotice({ hiddenCount }) {
  if (hiddenCount <= 0) return null;
  const isSingular = hiddenCount === 1;
  return (
    <div
      className="mb-8 border border-gold/20 bg-gold/[0.04] px-5 py-4 text-sm text-white/70 flex items-start gap-3"
      data-testid="filter-notice"
    >
      <Info className="w-4 h-4 text-gold mt-0.5 flex-shrink-0" />
      <div>
        <strong className="text-white">{hiddenCount}</strong>{" "}
        {isSingular ? "lotto nascosto" : "lotti nascosti"} dai tuoi filtri. Rimuovi o amplia i filtri per vederli tutti.
        <div className="text-xs text-white/45 mt-1">
          Nota: i lotti in chiusura negli ultimi ~30 minuti vengono spostati da Catawiki sulla loro <em>asta live</em> e non compaiono più nella ricerca pubblica.
        </div>
      </div>
    </div>
  );
}
